import { render, staticRenderFns } from "./BloodPressureCard.vue?vue&type=template&id=151dc070&scoped=true&"
import script from "./BloodPressureCard.vue?vue&type=script&lang=js&"
export * from "./BloodPressureCard.vue?vue&type=script&lang=js&"
import style0 from "./BloodPressureCard.vue?vue&type=style&index=0&id=151dc070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151dc070",
  null
  
)

export default component.exports